import {z} from 'zod';
import {baseCardSchema} from './baseSchemas';
import {NodeType} from 'common/src/modules/nodes/nodes.types';

export const sequenceCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.SEQUENCE),
  repeats: z
    .array(
      z.object({
        name: z.string().describe('The name of the sequence'),
        timesToRepeat: z.number().describe('The number of times to repeat for the sequence'),
      }),
    )
    .describe('The number of times to repeat for each sequence'),
  numberOfTimesToRepeat: z
    .number()
    .nullable()
    .describe(
      'The number of times the card flow will be repeated. If not provided, the repeats will continue with no end',
    ),
});
